import { render } from "./LinkedCustomersModal.vue?vue&type=template&id=8f4a3f80"
import script from "./LinkedCustomersModal.vue?vue&type=script&lang=js"
export * from "./LinkedCustomersModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__